import { reduxKey } from './constants';
import {
  setWatchingState,
  clickWatch,
  requestFailure,
  requestSuccess,
} from './actionCreators';
import { handleActions } from 'redux-actions';
import { WatchButtonState, WatchButtonUserState } from './types';

function setUserState(
  state: WatchButtonState,
  username: string,
  value: Partial<WatchButtonUserState>
) {
  if (!username) {
    return state;
  }

  const normalizedUsername = username.toLowerCase();

  return {
    ...state,
    [normalizedUsername]: {
      ...state[normalizedUsername],
      ...value,
    },
  };
}

const actionHandlers = handleActions<WatchButtonState, any>(
  {
    [clickWatch.toString()]: (
      state,
      {
        payload: {
          user: { username },
        },
      }: ReturnType<typeof clickWatch>
    ) =>
      setUserState(state, username, {
        isLoading: true,
      }),
    [requestFailure.toString()]: (
      state,
      { payload: { username } }: ReturnType<typeof requestFailure>
    ) =>
      setUserState(state, username, {
        isLoading: false,
      }),
    [requestSuccess.toString()]: (
      state,
      { payload: { username, isWatching } }: ReturnType<typeof requestSuccess>
    ) =>
      setUserState(state, username, {
        isLoading: false,
        isWatching,
      }),
    [setWatchingState.toString()]: (
      state,
      { payload: { username, isWatching } }: ReturnType<typeof setWatchingState>
    ) =>
      setUserState(state, username, {
        isLoading: false,
        isWatching,
      }),
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
